import { render, staticRenderFns } from "./EditingDFRadio.vue?vue&type=template&id=ae055f36&"
import script from "./EditingDFRadio.vue?vue&type=script&lang=js&"
export * from "./EditingDFRadio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports